import React from 'react';

interface SVGFileProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGFile = ({
  width = '20',
  height = '20',
  color = '#000',
  strokeWidth = '1.66667',
}: SVGFileProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 10.833H6.66666"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 14.167H6.66666"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33332 7.5H7.49999H6.66666"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 5C3 3.11438 3 2.17157 3.58579 1.58579C4.17157 1 5.11438 1 7 1H11C12.1046 1 13 1.89543 13 3V3C13 4.10457 13.8954 5 15 5V5C16.1046 5 17 5.89543 17 7V15C17 16.8856 17 17.8284 16.4142 18.4142C15.8284 19 14.8856 19 13 19H7C5.11438 19 4.17157 19 3.58579 18.4142C3 17.8284 3 16.8856 3 15V5Z"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

export default SVGFile;
